module.exports = __webpack_public_path__ + "static/media/xueshengzheng.85cc5a97.png";